import { AjaxHelper } from "@samc/common"

export class LSService {
  private readonly _helper: AjaxHelper;

  public constructor(verificationToken: string | null, client: string | null, jwt: string | null) {
    this._helper = new AjaxHelper("/ls", verificationToken, client, jwt);
  }

  public async getDomainIdByDomainName(domainName: string) {
    return await this._helper.getData<number | null>(`${domainName}/domainid`);
  }
}